import { useRouter } from 'next/router'
import { useEffect, useState, VFC } from 'react'
import { useFeedbackRooms } from 'src/api/room'
import { FreeTrialModal } from 'src/components/Modal/FreeTrialModal'
import { MessageModal } from 'src/components/Modal/MessageModal'
import { FeedbackModal } from 'src/compositions/Feedback/FeedbackModal'
import { AlertModal } from 'src/compositions/Messages/Modals/AlertModal'
import { useAlerts } from 'src/hooks/useAlert'
import { useFreeTrial } from 'src/hooks/useFreeTrial'

const TARGET_PATHS_FOR_MODAL = ['/companies', '/events', '/contributions']
export const shouldDisplayModal = (currentPath: string) =>
  TARGET_PATHS_FOR_MODAL.some((targetPath) =>
    currentPath.startsWith(targetPath),
  )

export const Modals: VFC = () => {
  const {
    alerts,
    isAlertModalOpen,
    isReportedModalOpen,
    report,
    closeAlertModal,
    closeReportedModal,
  } = useAlerts()
  const router = useRouter()
  const { elapsedDays, isFreeTrialModalOpen, register, closeFreeTrialModal } =
    useFreeTrial()
  const { data: data, mutate: mutateFeedbackRooms } = useFeedbackRooms()
  const { feedbackRooms, feedbackArticleId } = data || {
    feedbackRooms: [],
    feedbackArticleId: undefined,
  }
  const [displayModal, setDisplayModal] = useState<boolean>(false)

  // NOTE: メッセージとフィードバック画面以外でモーダル表示
  // WARNING: useState で初期値をセットすると pathname を認識しない場合があるため useEffect で処理
  useEffect(() => {
    if (
      feedbackRooms &&
      feedbackRooms?.length > 0 &&
      router.pathname != '/companies/messages' &&
      router.pathname != '/companies/feedbacks'
    )
      setDisplayModal(true)
  }, [feedbackRooms, router.pathname])

  // NOTE: mutate されて feedback する部屋がなくなったらモーダルを閉じる
  useEffect(() => {
    if (feedbackRooms?.length === 0) setDisplayModal(false)
  }, [feedbackRooms])

  return (
    <>
      {displayModal ? (
        <FeedbackModal
          close={() => setDisplayModal(false)}
          feedbackRooms={feedbackRooms || []}
          mutate={mutateFeedbackRooms}
          feedbackArticleId={feedbackArticleId}
        />
      ) : isAlertModalOpen && alerts.length > 0 ? (
        <AlertModal
          content={alerts[0].content}
          report={report}
          close={closeAlertModal}
        />
      ) : isReportedModalOpen ? (
        <MessageModal
          message={'問題の解決を報告しました'}
          close={closeReportedModal}
        />
      ) : elapsedDays != null && isFreeTrialModalOpen ? (
        <FreeTrialModal
          elapsedDays={elapsedDays}
          register={register}
          close={closeFreeTrialModal}
        />
      ) : null}
    </>
  )
}

export const GuestModals: VFC = () => {
  const {
    alerts,
    isAlertModalOpen,
    isReportedModalOpen,
    report,
    closeAlertModal,
    closeReportedModal,
  } = useAlerts()

  return (
    <>
      {isAlertModalOpen && alerts.length > 0 ? (
        <AlertModal
          content={alerts[0].content}
          report={report}
          close={closeAlertModal}
        />
      ) : (
        isReportedModalOpen && (
          <MessageModal
            message={'問題の解決を報告しました'}
            close={closeReportedModal}
          />
        )
      )}
    </>
  )
}
